exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:768px){.module-selection-title[data-v-7f22145a]{font-size:.7em}}", ""]);

// exports
